<template>
  <v-expansion-panel class="you-tube-radio" style="width: 770px; min-width: 770px; display: block;" :popout="true" v-model="open">
    <v-expansion-panel-content class="primary">
      <template v-slot:header>
        <div class="title">
          <span v-if="!active" style="opacity: 0.5;">YouTube Radio</span>
          <span v-else style="opacity: 0.5;">Now Playing:</span>
          &nbsp;
          <b v-if="currentSong && currentSong.artist">{{currentSong.t}} - {{currentSong.artist.n}}</b>
        </div>
      </template>

      <v-card class="primary" style="height: 470px">
        <v-card-text>
          <v-layout row justify-space-between>
            <v-flex class="pr-5">
              <v-layout column>
                <v-flex class="text-xs-center">
                  <v-btn @click="previous()" :disabled="!active" fab small color="secondary--text">
                    <v-icon>fa-step-backward</v-icon>
                  </v-btn>
                  <v-btn @click="play()" :disabled="playableVideos.length === 0" fab color="secondary--text">
                    <v-icon>{{playIcon}}</v-icon>
                  </v-btn>
                  <!-- <v-btn fab small color="secondary--text">
                    <v-icon>fa-stop</v-icon>
                  </v-btn> -->
                  <v-btn @click="next()" :disabled="!active" fab small color="secondary--text">
                    <v-icon>fa-step-forward</v-icon>
                  </v-btn>

                  <v-tooltip top>
                    <template slot="activator">
                      <v-btn :disabled="!currentSong" fab small color="silver--text" :to="{name: 'song-info', params: {id: (currentSong && currentSong.id) || 0}}">
                        <v-icon>fa-compact-disc</v-icon>
                      </v-btn>
                    </template>
                    <span>View Song Page</span>
                  </v-tooltip>

                  <v-dialog class="you-tube-radio-modal" v-model="dialog" max-width="800">
                    <template slot="activator">
                      <slot>
                        <v-tooltip top>
                          <template slot="activator">
                            <v-btn fab small color="silver--text">
                              <v-icon>fas fa-sliders-h</v-icon>
                            </v-btn>
                          </template>
                          <span>Radio Settings</span>
                        </v-tooltip>
                      </slot>
                    </template>

                    <v-card>
                      <v-card-title class="black">
                        <h2 class="pl-2 text-uppercase font-weight-light">
                          YouTube Radio Settings
                        </h2>
                      </v-card-title>

                      <v-card-text>
                        <v-layout column>
                          <v-flex>
                            <v-layout row wrap align-content-center>
                              <v-flex>
                                <v-switch class="mt-0 pt-0" hide-details v-model="settings.shuffle" color="secondary" label="Shuffle"></v-switch>
                              </v-flex>
                              <v-flex xs12 sm5>
                                <v-text-field color="secondary" hide-details reverse append-outer-icon="fa-percentage" type="number" v-model="settings.playback_speed_change" label="Playback Speed Change" step="1" min="-99" max="100"></v-text-field>
                              </v-flex>
                            </v-layout>

                          </v-flex>
                          <v-flex class="subheading mt-3">
                            <v-divider class="mb-3 secondary"/>
                            Based on the filters below, <b class="secondary--text">{{playableVideos.length}}</b> songs can be played.
                          </v-flex>
                          <v-flex>
                            <v-switch hide-details v-model="settings.euro" color="secondary" label="Include Eurobeat songs"></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch hide-details v-model="settings.techno" color="secondary" label="Include Techno songs"></v-switch>
                          </v-flex>
                          <v-flex>
                            <v-switch hide-details v-model="settings.trance" color="secondary" label="Include Trance songs"></v-switch>
                          </v-flex>

                          <v-flex class="subheading mt-4">
                            <v-divider class="mb-3 secondary"/>
                            The following filters only work if you are signed in.
                          </v-flex>

                          <v-layout row wrap>
                            <v-flex sm6>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.unrated" color="secondary" label="Include unrated songs"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.rating_5" color="secondary" :label="`Include songs rated: ${$options.ratings['5'].name}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.rating_4" color="secondary" :label="`Include songs rated: ${$options.ratings['4'].name}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.rating_3" color="secondary" :label="`Include songs rated: ${$options.ratings['3'].name}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.rating_2" color="secondary" :label="`Include songs rated: ${$options.ratings['2'].name}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.rating_1" color="secondary" :label="`Include songs rated: ${$options.ratings['1'].name}`"></v-switch>
                            </v-flex>

                            <v-flex sm6>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_0" color="secondary" label="Include songs without training status"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_C" color="secondary" :label="`Include training status: ${$options.training_statuses.get('C').d}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_F" color="secondary" :label="`Include training status: ${$options.training_statuses.get('F').d}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_P" color="secondary" :label="`Include training status: ${$options.training_statuses.get('P').d}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_W" color="secondary" :label="`Include training status: ${$options.training_statuses.get('W').d}`"></v-switch>
                              <v-switch hide-details class="pb-0 mb-0" v-model="settings.training_N" color="secondary" :label="`Include training status: ${$options.training_statuses.get('N').d}`"></v-switch>
                            </v-flex>
                          </v-layout>

                        </v-layout>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <div>
                          <v-btn color="secondary" flat @click="dialog = false">Close</v-btn>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>

                <v-flex @wheel.prevent="scrollVolume">
                  <v-slider always-dirty color="secondary" v-model="volume" min="0" max="100">
                    <template v-slot:prepend>
                      <v-icon color="black" @click="decrementVolume()" class="mr-0">
                        fa-volume-down
                      </v-icon>
                    </template>

                    <template v-slot:append>
                      <v-icon color="black" @click="incrementVolume()" class="ml-1">
                        fa-volume-up
                      </v-icon>
                    </template>
                  </v-slider>
                </v-flex>
                <v-flex v-if="currentSong" class="text-xs-center">
                  <song-rating-modal :song="currentSong" class="pt-2 pl-2 pr-2"/>
                  <training-status-modal :song="currentSong" class="pt-2 pl-2"/>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex shrink>
              <div v-show="player === 1">
                <div class="yt-player-1" style="width: 350px; height: 200px;"></div>
              </div>
              <div v-show="player === 2">
                <div class="yt-player-2" style="width: 350px; height: 200px;"></div>
              </div>
            </v-flex>
          </v-layout>

        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>

import RATINGS from '../constants/ratings'
import TRAINING_STATUSES from '../constants/training-statuses'
import YTPlayer from 'yt-player'
import { shuffle } from 'fast-shuffle'

import SongRatingModal from '@/components/SongRatingModal.vue'
import TrainingStatusModal from '@/components/TrainingStatusModal.vue'

const YT_RADIO_SETTINGS_KEY = 'PPD_YT_Radio_Settings'

export default {
  name: 'you-tube-radio',

  // YT players. We use two players for transitions.
  player1: null,
  player2: null,

  ratings: RATINGS,
  training_statuses: TRAINING_STATUSES,

  props: {
    extras: Object
  },

  data () {
    return {
      open: null, // set to 0 to open the panel
      settings: {
        fade_duration: 5,
        playback_speed_change: 0, // percentage: 100% means 2x
        shuffle: true,
        euro: true,
        techno: true,
        trance: true,
        unrated: true,
        rating_1: false,
        rating_2: false,
        rating_3: true,
        rating_4: true,
        rating_5: true,
        training_0: true,
        training_N: true,
        training_W: true,
        training_P: true,
        training_C: true,
        training_F: true
      },
      settingsLoaded: false,
      unplayableVideoIds: [],
      dialog: false,
      volume: 100,
      active: false,
      currentVideo: null,
      currentSong: null,
      currentVideoIndex: -1,

      playing1: false,
      playing2: false,
      duration1: 0, // duration in seconds of the video loaded in player 1
      duration2: 0,

      player: 1 // Current player. Should be a number (1 or 2)
    }
  },

  computed: {
    isPlaying () {
      return this.playing1 || this.playing2
    },

    playIcon () {
      if (!this.active) return 'fa-power-off'

      return this.isPlaying ? 'fa-pause' : 'fa-play'
    },

    selectedGenres () {
      var settings = this.settings
      var genres = []
      if (settings.euro) { genres.push('eu') }
      if (settings.techno) { genres.push('te') }
      if (settings.trance) { genres.push('tr') }
      return genres
    },

    selectedRatings () {
      var settings = this.settings
      var ratings = []
      if (settings.unrated) { ratings.push('0') }
      if (settings.rating_1) { ratings.push('1') }
      if (settings.rating_2) { ratings.push('2') }
      if (settings.rating_3) { ratings.push('3') }
      if (settings.rating_4) { ratings.push('4') }
      if (settings.rating_5) { ratings.push('5') }
      return ratings
    },

    selectedTrainingStatuses () {
      var settings = this.settings
      var statuses = []
      if (settings.training_0) { statuses.push('0') }
      if (settings.training_N) { statuses.push('N') }
      if (settings.training_W) { statuses.push('W') }
      if (settings.training_P) { statuses.push('P') }
      if (settings.training_C) { statuses.push('C') }
      if (settings.training_F) { statuses.push('F') }
      return statuses
    },

    // Returns Audio Track videos with filters applied.
    filteredVideos () {
      var genres = this.selectedGenres
      var ratings = this.selectedRatings
      var training = this.selectedTrainingStatuses

      return this.shuffledVideos.filter(v => {
        var song = v.sng[0].song
        if (!song) return false
        if (genres.indexOf(song.g) < 0) return false
        return ratings.indexOf(song.uR) >= 0 && training.indexOf(song.uT) >= 0
      })
    },

    // Removes unplayable videos from the filtered result.
    playableVideos () {
      var unplayable = this.unplayableVideoIds

      return this.filteredVideos.filter(v => {
        return (unplayable.indexOf(v.i) < 0)
      })
    },

    // Shuffles all audio tracks. This is cached before filters, so that
    // order does not change when filters are changed or unplayables are removed.
    // List will be reshuffled if the setting is retoggled.
    shuffledVideos () {
      return this.settings.shuffle ? shuffle(this.audioVideos) : this.audioVideos
    },

    // Returns playable Audio Track videos that have at least one song.
    audioVideos () {
      return this.$database.videos.array.filter(v => {
        if (v.c !== 'au') return false

        // Not embeddable or playable
        if (v._e === false || v._p === false) return false

        var sng = v.sng[0]
        if (!sng) return false

        return !!sng.song
      })
    },

    userId () {
      return this.$api.session.data.user_id
    }
  },

  created () {
    this.loadSettingsFromLocalStorage()
  },

  methods: {
    play () {
      if (!this.active) this.activate()

      if (!this.isPlaying) {
        this.playCurrent()
      } else {
        this.pause()
      }
    },

    // Called when users click the Headphone icon in song listings.
    // This replaces the song currently being played.
    instantPlay (video) {
      if (!this.active) this.activate()

      this.open = 0 // opens radio widget

      this.currentVideo = video
      this.currentSong = this.currentVideo.sng[0].song

      var startAt = this.currentVideo.sng[0].s || 0

      console.debug('(InstantPlay) Preparing to play on player', this.player, this.currentSong.ac)

      var player = this.getCurrentPlayer()
      player.load(this.currentVideo.i, true, startAt)
      player.setVolume(100 * (this.volume / 100))
      this.updatePlaybackRate()

      player.play()
    },

    activate () {
      var options = { autoplay: false, controls: true, captions: false, keyboard: false, fullscreen: false, annotations: false, modestBranding: true, related: false }
      this.$options.player1 = new YTPlayer('.yt-player-1', options)
      this.$options.player2 = new YTPlayer('.yt-player-2', options)

      this.$options.player1.on('timeupdate', this.videoUpdate1)
      this.$options.player2.on('timeupdate', this.videoUpdate2)

      this.$options.player1.on('playing', () => { this.playing1 = true })
      this.$options.player2.on('playing', () => { this.playing2 = true })
      this.$options.player1.on('paused', () => { this.playing1 = false })
      this.$options.player2.on('paused', () => { this.playing2 = false })
      this.$options.player1.on('ended', () => { this.playNext() })
      this.$options.player2.on('ended', () => { this.playNext() })
      this.$options.player1.on('cued', () => { this.duration1 = this.$options.player1.getDuration() })
      this.$options.player2.on('cued', () => { this.duration2 = this.$options.player2.getDuration() })
      this.$options.player1.on('unplayable', this.onUnplayable)
      this.$options.player2.on('unplayable', this.onUnplayable)

      this.active = true

      this.player = 1
      this.currentVideoIndex = 0
      this.prepareCurrent()
    },

    getCurrentPlayer () {
      return (this.player === 1) ? this.$options.player1 : this.$options.player2
    },

    getOtherPlayer () {
      return (this.player === 1) ? this.$options.player2 : this.$options.player1
    },

    pause () {
      var player = this.getCurrentPlayer()
      player.pause()
    },

    next () {
      if (this.playableVideos.length === 0) return

      this.playNext()
    },

    previous () {
      var source = this.playableVideos
      if (source.length === 0) return

      this.currentVideoIndex--

      if (this.currentVideoIndex < 0) {
        this.currentVideoIndex = source.length - 1
      }

      var player = this.getCurrentPlayer()

      // Switches players
      if (this.player === 1) {
        this.player = 2
      } else {
        this.player = 1
      }

      this.prepareCurrent()
      player.pause() // Stop current track
      this.playCurrent()
    },

    prepareCurrent () {
      if (!this.active) return

      var source = this.playableVideos
      if (source.length === 0) return

      this.currentVideo = source[this.currentVideoIndex]
      this.currentSong = this.currentVideo.sng[0].song

      var startAt = this.currentVideo.sng[0].s || 0

      console.debug('Preparing to play on player', this.player, this.currentSong.ac)

      var player = this.getCurrentPlayer()
      player.load(this.currentVideo.i, true, startAt)
      player.pause()
      this.updatePlaybackRate()
      player.setVolume(100 * (this.volume / 100))
    },

    playCurrent () {
      if (!this.active) return
      if (!this.currentVideo) return

      console.debug('Player', this.player, 'is now playing', this.currentSong.ac)
      var player = this.getCurrentPlayer()
      player.play()
      this.prepareNext()
      this.saEvent('radio_play', {
        user_id: this.userId,
        song_id: this.currentSong.id
      })
    },

    prepareNext () {
      if (!this.active) return

      var source = this.playableVideos
      if (source.length === 0) return

      var index = this.currentVideoIndex + 1

      if (index + 1 > source.length) {
        index = 0
      }

      console.debug('Prepared next song, index', index)

      var video = source[index]
      var startAt = video.sng[0].s || 0
      var player = this.getOtherPlayer()

      player.load(video.i, true, startAt)
      player.pause()
      this.updatePlaybackRate()
      player.setVolume(100 * (this.volume / 100))
    },

    playNext () {
      if (!this.active) return

      var source = this.playableVideos
      if (source.length === 0) return

      this.currentVideoIndex++

      if (this.currentVideoIndex + 1 > source.length) {
        this.currentVideoIndex = 0
      }

      this.currentVideo = source[this.currentVideoIndex]
      this.currentSong = this.currentVideo.sng[0].song

      var player
      if (this.player === 1) {
        this.player = 2
        this.duration1 = 0 // resets duration of the other video
        this.playing1 = false
        player = this.$options.player2
      } else {
        this.player = 1
        this.duration2 = 0
        this.playing2 = false
        player = this.$options.player1
      }

      console.debug('Playing next on player', this.player, this.currentSong)

      player.play()

      this.prepareNext()

      this.saEvent('radio_play', {
        user_id: this.userId,
        song_id: this.currentSong.id
      })
    },

    videoUpdate1 (seconds) {
      return this.videoUpdate(seconds, 1)
    },

    videoUpdate2 (seconds) {
      return this.videoUpdate(seconds, 2)
    },

    videoUpdate (_seconds, _index) {
      // NO-OPS FOR NOW
      // TODO: implement fading

      // if (index !== this.player) return

      // var currentDuration = this.player === 1 ? this.duration1 : this.duration2
      // if (currentDuration === 0) return

      // var timeLeft = currentDuration - seconds
      // console.debug('Video update', index, seconds, 'time left', timeLeft)

      // var currentPlayer = this.player === 1 ? this.$options.player1 : this.$options.player2
    },

    decrementVolume () {
      this.volume -= 20
    },

    incrementVolume () {
      this.volume += 20
    },

    scrollVolume (event) {
      if (event.deltaY > 0) {
        this.volume -= 10
      } else if (event.deltaY < 0) {
        this.volume += 10
      }
    },

    onUnplayable (videoId) {
      console.debug('Unplayable Video ID', videoId)
      this.saEvent('radio_unplayable', {
        video_id: this.currentVideo.id,
        song_id: this.currentSong.id
      })

      this.unplayableVideoIds.push(videoId)

      this.$nextTick(() => {
        if (!this.isPlaying) {
          // This can happen if the very first song is unplayable.
          this.prepareCurrent()
          this.playCurrent()
        } else {
          // Triggered when the next song is loaded (more common scenario).
          // By waiting for nextTick, unplayable ID array will have been updated,
          // and collections should be refreshed, causing the next ID to skip
          // the unplayable one.
          this.prepareNext()
        }
      })
    },

    updatePlaybackRate () {
      var rate = 1.0 * (1 + (this.settings.playback_speed_change / 100))
      console.debug('Playback Rate set to', rate)

      var player1 = this.$options.player1
      var player2 = this.$options.player2

      if (player1) player1.setPlaybackRate(rate)
      if (player2) player2.setPlaybackRate(rate)
    },

    loadSettingsFromLocalStorage () {
      var settingsFromLS = localStorage.getItem(YT_RADIO_SETTINGS_KEY)

      if (!settingsFromLS) {
        console.debug('No settings found in LocalStorage. Saving a fresh copy.')
        this.settingsLoaded = true
        this.saveSettingsToLocalStorage()
        return
      }

      try {
        settingsFromLS = JSON.parse(settingsFromLS)
      } catch (e) {
        console.debug('Settings in LocalStorage are invalid. Saving a fresh copy.', e)
        this.settingsLoaded = true
        this.saveSettingsToLocalStorage()
        return
      }

      console.debug('Loading settings from LocalStorage')

      var settings = this.settings
      var keys = Object.keys(settings)

      for (var key of keys) {
        if (settingsFromLS[key] != null) {
          settings[key] = settingsFromLS[key]
        }
      }

      // Prevents the watcher from saving settings while loading.
      this.$nextTick(() => {
        this.settingsLoaded = true
      })
    },

    saveSettingsToLocalStorage () {
      console.debug('Saving settings to LocalStorage')

      localStorage.setItem(YT_RADIO_SETTINGS_KEY, JSON.stringify(this.settings))
    }
  },

  beforeDestroy () {
    console.debug('Destroying listeners')

    var player1 = this.$options.player1
    var player2 = this.$options.player2

    if (player1) player1.removeAllListeners()
    if (player2) player2.removeAllListeners()
  },

  watch: {
    volume (value) {
      var player1 = this.$options.player1
      var player2 = this.$options.player2

      if (player1) player1.setVolume(100 * (value / 100))
      if (player2) player2.setVolume(100 * (value / 100))
    },

    playableVideos (_value) {
      console.debug('Re-preparing next track due to song list update')
      this.prepareNext()
    },

    'settings.playback_speed_change' () {
      this.updatePlaybackRate()
    },

    settings: {
      handler: function () {
        if (!this.settingsLoaded) return

        this.saveSettingsToLocalStorage()
      },
      deep: true
    },

    'extras.instantVideo': function (val) {
      this.instantPlay(val)
    }
  },

  components: { SongRatingModal, TrainingStatusModal }
}
</script>
